import { FC } from "react";
import { IncreaseOfShareCapitalForm } from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { VBox } from "@/components-v2/Box";
import { MCheckboxGroup } from "@/components-v2/Checkbox";
import { useTranslation } from "@/stores/RootStoreContext";
import { Dialog } from "@/components-v2/Dialog";
import { Markdown } from "@/text/Markdown";
import { customDocumentTypeLabels } from "@/dbot/customDocument/customDocumentDomain";
import { TMessage } from "@/i18n/tt";

const ShareCapitalIncreaseMethod: FC<{ form: IncreaseOfShareCapitalForm }> = observer(
  ({ form }) => {
    const { t } = useTranslation();
    return (
      <VBox>
        <div>{t("decisions.increaseShareCapitalAgainstCash.selectIncreaseType")}</div>
        <MCheckboxGroup
          model={form.contributionTypes}
          disabled={form.isProjectLocked}
          onChange={form.changeContributionTypes}
        />
      </VBox>
    );
  },
);

export const ShareCapitalIncreaseMethod2: FC<{ form: IncreaseOfShareCapitalForm }> = observer(
  ({ form }) => {
    const { t } = useTranslation();
    return (
      <VBox>
        <div>{t("decisions.increaseShareCapitalAgainstCash.selectIncreaseType2")}</div>
        <MCheckboxGroup
          model={form.contributionTypes}
          disabled={form.isProjectLocked}
          onChange={form.changeContributionTypes}
        />
      </VBox>
    );
  },
);

export const AskToAddBoardStatementDocumentDialog: FC<{ form: IncreaseOfShareCapitalForm }> =
  observer(({ form }) => {
    const { t } = useTranslation();
    const documentLabels: TMessage[] | undefined =
      form.askToAddBoardStatement?.map((d) => customDocumentTypeLabels[d]) ?? undefined;

    if (!documentLabels) {
      return null;
    }

    return (
      <Dialog
        title={t("dbot.documents-required")}
        submitResult={form.addBoardStatementResult}
        onSubmit={form.addBoardStatementDocument}
        onCancel={() => form.setAskToAddBoardStatement()}
        submitLabel={t("yes")}
        cancelLabel={t("no")}
      >
        <VBox>
          {t("dbot.documents-required.description")}
          {<Markdown value={documentLabels.map((l) => `- ${t(l)}`).join(" \n")} />}
          {t("dbot.documents-required.ask-to-add")}
        </VBox>
      </Dialog>
    );
  });

export default ShareCapitalIncreaseMethod;
